import { render, staticRenderFns } from "./SubOrderChangeModal.vue?vue&type=template&id=73a4e31c&scoped=true&"
import script from "./SubOrderChangeModal.vue?vue&type=script&lang=js&"
export * from "./SubOrderChangeModal.vue?vue&type=script&lang=js&"
import style0 from "./SubOrderChangeModal.vue?vue&type=style&index=0&id=73a4e31c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a4e31c",
  null
  
)

export default component.exports